import React from "react";
import Banner from "@hig/banner";
import Button from "@hig/button";

const bannerStyles = (styles) => {
  return {
    ...styles,
    banner: {
      ...styles.banner,
      maxHeight: "50px",
    },
    content: {
      ...styles.content,
      margin: "0 0 0 16px",
      alignItems: "baseline",
    },
  };
};

const buttonStyles = {
  margin: "2px 0 0 0",
  maxHeight: "34px",
};

const NegativeBanner = () => {
  return (
    <Banner
      type="urgent"
      stylesheet={bannerStyles}
      actions={() => (
        <Banner.Interactions>
          <Banner.Action>
            <Button
              data-test-id="neg-bal-banner-buy-tokens-button"
              data-external-target="neg-bal-banner-buy-tokens-button"
              size="standard"
              title={"Buy tokens"}
              type="secondary"
              width="shrink"
              link="//aps.autodesk.com/pricing"
              target="_blank"
              style={buttonStyles}
            />
          </Banner.Action>
        </Banner.Interactions>
      )}
    >
      <strong>You have run out of tokens.</strong>{" "}To avoid service disruption, please purchase more tokens.
    </Banner>
  );
};

export default NegativeBanner;
